import classNames from 'classnames/bind';

import styles from './S06.module.scss';
import product01 from '../../../assets/images/products/oneday/s06/500ml.jpg';
import product02 from '../../../assets/images/products/oneday/s06/2L.jpg';
import Nutrient from '../../../components/product/Nutrient';
import Products from '../../../components/product/Products';

const cx = classNames.bind(styles);

const S02 = () => {
  return (
    <div className={cx('container')}>
      <div className={cx('limiter')}>
        <Products
          products={[
            { sub: '외출 시에 편하게 한 잔!', title: '하루귀리 500mL', image: product01, text: '500mL × 20개입' },
            { sub: '집에서도 늘 건강한 습관', title: '하루귀리 1.5L', image: product02, text: '1.5L × 12개입' },
          ]}
          color="#9F5500"
        />
        <Nutrient
          data={{
            head: ['열량', '나트륨', '탄수화물', '당류', '지방', '트랜스지방', '포화지방', '콜레스테롤', '단백질'],
            body: [
              ['500ml', '0Kcal', '5mg(0%)', '1g 미만(0%)', '0g(0%)', '0g(0%)', '0g', '0g(0%)', '0mg(0%)', '0g(0%)'],
              ['1.5L', '0Kcal', '0mg(0%)', '0g 미만(0%)', '0g(0%)', '0g(0%)', '0g', '0g(0%)', '0mg(0%)', '0g(0%)'],
            ],
          }}
          color="#EFDFCB"
          leading
        />
      </div>
    </div>
  );
};

export default S02;
